import { createReducer } from '@reduxjs/toolkit'
import {
  setMarketFilter,
  setMyNftFilter,
  setDeleteLabelId,
  setMyNftDeleteLabelId,
  setMarketFilterMinPrice,
  setMarketFilterMaxPrice,
  setMyNFTFilterMinPrice,
  setMyNFTFilterMaxPrice,
  setUnbindInfo,
  setOpenFilter,
} from './actions'
import { NFTFilterTypes, UnbindInfoTypes } from '../types'

export interface NFTState {
  readonly marketFilter: Array<NFTFilterTypes>
  readonly myNftFilter: Array<NFTFilterTypes>
  readonly deleteLabelId: string
  readonly myNftDeleteLabelId: string
  readonly marketFilterMinPrice: string
  readonly marketFilterMaxPrice: string
  readonly myNFTFilterMinPrice: string
  readonly myNFTFilterMaxPrice: string
  readonly openFilter: boolean
  readonly unbindInfo: UnbindInfoTypes
}

const inintSate: NFTState = {
  marketFilter: [],
  myNftFilter: [],
  deleteLabelId: '',
  myNftDeleteLabelId: '',
  marketFilterMinPrice: '',
  marketFilterMaxPrice: '',
  myNFTFilterMinPrice: '',
  myNFTFilterMaxPrice: '',
  openFilter: false,
  unbindInfo: {
    realm: '',
    roleId: '',
    serverId: '',
    worldRealm: '',
    worldRealmName: '',
    serverName: '',
    realmName: '',
    roleName: '',
    num: 0,
  },
}

export default createReducer(inintSate, builder => {
  builder
    .addCase(setMarketFilter, (state, action) => {
      state.marketFilter = []
      try {
        if (action.payload && action.payload.length > 0) {
          state.marketFilter = action.payload.sort((a: NFTFilterTypes, b: NFTFilterTypes) => {
            return a.sort - b.sort
          })
        }
      } catch (error) {
        console.error(error)
      }
    })
    .addCase(setMyNftFilter, (state, action) => {
      if (action.payload && action.payload.length > 0) {
        state.myNftFilter = action.payload.sort((a: NFTFilterTypes, b: NFTFilterTypes) => {
          return a.sort - b.sort
        })
      } else {
        state.myNftFilter = []
      }
    })
    .addCase(setDeleteLabelId, (state, action) => {
      state.deleteLabelId = action.payload
    })
    .addCase(setMyNftDeleteLabelId, (state, action) => {
      state.deleteLabelId = action.payload
    })
    .addCase(setMarketFilterMinPrice, (state, action) => {
      state.marketFilterMinPrice = action.payload
    })
    .addCase(setMarketFilterMaxPrice, (state, action) => {
      state.marketFilterMaxPrice = action.payload
    })
    .addCase(setMyNFTFilterMinPrice, (state, action) => {
      state.marketFilterMinPrice = action.payload
    })
    .addCase(setMyNFTFilterMaxPrice, (state, action) => {
      state.marketFilterMaxPrice = action.payload
    })
    .addCase(setUnbindInfo, (state, action) => {
      state.unbindInfo = action.payload
    })
    .addCase(setOpenFilter, (state, action) => {
      state.openFilter = action.payload
    })
})
